import { render } from "./BaseEditor.vue?vue&type=template&id=572e06a6"
import script from "./BaseEditor.vue?vue&type=script&lang=js"
export * from "./BaseEditor.vue?vue&type=script&lang=js"

import "./BaseEditor.vue?vue&type=style&index=0&id=572e06a6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__